<mat-nav-list>
  @for (m of menuItems; track m) {
    <a mat-list-item [routerLink]="[m.path]" routerLinkActive="menu-item--simple-active">
      @if (m.icon !== undefined) {
        <span matListItemIcon>
          <mat-icon>{{m.icon}}</mat-icon>
        </span>
      }
      <span matListItemTitle>{{ m.name }}</span>
    </a>
  }
</mat-nav-list>
